/* global tinymce */
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="anchor-list"
export default class extends Controller {
  static targets = ["url", "anchor"];

  initialize() {
    this.#generateOptions();
    this.setSelectedOption();
  }

  updateLink() {
    const selectedAnchor = this.anchorTarget.value;
    this.#updateValue(this.urlTarget, selectedAnchor);
  }

  setSelectedOption() {
    const currentUrl = this.urlTarget.value;
    if (currentUrl.startsWith("#")) {
      const option = this.anchorTarget.querySelector(
        `option[value="${currentUrl}"]`
      );
      if (option) {
        option.selected = true;
        return;
      }
    }
    this.anchorTarget.selectedIndex = 0;
  }

  #generateOptions() {
    /*
        TinyMCE's anchors are written as
        <a id="anchor-name"></a>
     */
    const anchorLinks = tinymce.activeEditor?.dom.select("a:not([href])[id]");
    if (!anchorLinks?.length) return;

    const anchorIds = new Set(anchorLinks.map((link) => link.id));

    const options = document.createDocumentFragment();
    anchorIds.forEach((id) => {
      options.appendChild(this.#anchor_option(id));
    });
    this.anchorTarget.appendChild(options);
  }

  #anchor_option(value) {
    return new Option(value, `#${value}`);
  }

  #updateValue(element, value) {
    element.value = value;
    element.dispatchEvent(new Event("input", { bubble: true }));
  }
}
